import { addEvents, cleanEvents } from '../utils/event';

export default {
  props: {
    target: {
      type: [Boolean, String, Object],
      default: true,
    },
    noParentEvent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      anchorEl: null,
    };
  },
  watch: {
    target() {
      if (this.anchorEl) this.resetAnchorEl();
      this.pickAnchorEl();
    },
    noParentEvent(value) {
      if (this.anchorEl) {
        value ? this.resetAnchorEl() : this.setupAnchorEl();
      }
      this.pickAnchorEl();
    },
  },
  mounted() {
    this.pickAnchorEl();
  },
  beforeUnmount() {
    this.resetAnchorEl();
  },
  methods: {
    setAnchorEl(element) {
      this.anchorEl = element;
      this.setupAnchorEl();
    },
    pickAnchorEl() {
      let parent = null;

      if (this.$parent.$children.length >= 2) {
        parent = this.$el.parentNode;
      } else {
        parent = this.$parent.$el;
      }

      if (this.target === false || this.target === '' || parent === null) {
        this.anchorEl = null;
      } else if (this.target === true) {
        this.setAnchorEl(parent);
      } else {
        let element = this.target;

        if (typeof this.target === 'string') {
          try {
            element = document.querySelector(this.target);
          } catch (error) {
            element = null;
          }
        }

        if (element) {
          this.anchorEl = element.$el || element;
          this.setupAnchorEl();
        } else {
          this.anchorEl = null;
        }
      }
    },
    setupAnchorEl() {
      if (this.noParentEvent || !this.anchorEl) return;

      const events = [
        [this.anchorEl, 'click', 'modelToggle', 'passive'],
      ];

      addEvents(this, 'anchor', events);
    },
    resetAnchorEl() {
      cleanEvents(this, 'anchor');
    },
  },
};
